export const MENU_LIST = "menu_list";
export const DISH_PUT = "dish_put";
export const DISH_DELETE = "dish_delete";
export const CATEGORY_PUT = "category_put";
export const CATEGORY_DELETE = "category_delete";
